{
  "adobeExperienceCloudNoOrgsSelect": "Anderes Unternehmenskonto auswählen",
  "help": "Hilfe",
  "newAnnouncement": "Hat eine neue Ankündigung",
  "notification": "Benachrichtigungen und Ankündigungen",
  "profile": "Profil",
  "searchButton": "Suchen",
  "sidenavMenuCloseTooltip": "Menü schließen",
  "sidenavMenuOpenTooltip": "Menü öffnen",
  "solutionSwitcher": "Zu anderer Lösung wechseln",
  "unread": "ungelesene Benachrichtigungen"
}
